<script>
export default {
  name: 'EmptyBookingsFound',
  props: {
    currentTabName: { type: String, required: true },
  },
  computed: {
    formattedTabName() {
      return this.currentTabName
        .replace(/([A-Z])/g, ' $1')
        .trim()
        .toLowerCase()
    },
  },
}
</script>

<template>
  <div class="empty-block">
    <div class="content">
      <h1>{{ $t('emptyBookings.label', { tab: formattedTabName }) }}</h1>
      <p>{{ $t('emptyBookings.paragraph') }}</p>

      <div class="button">
        <BaseButton
          class="create-booking-btn"
          prepend-icon="mdi mdi-plus"
          width="170"
          @click="$router.push({ name: 'bookings-create' })"
        >
          {{ $t('bookingCreate.submitBtn') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/no-booking-found.scss';
</style>
